import { AiFillLinkedin } from 'react-icons/ai';
import { AiFillGithub } from 'react-icons/ai';

const data = [
  {
    id: 1,
    link: 'https://www.linkedin.com/in/enes-chatzi-osman-9b38ba19b/',
    icon: <AiFillLinkedin />,
  },
  { id: 2, link: 'https://github.com/echatziosman', icon: <AiFillGithub /> },
];

export default data;
